import { render, staticRenderFns } from "./DashHeader.vue?vue&type=template&id=538a1eee&scoped=true&"
import script from "./DashHeader.vue?vue&type=script&lang=js&"
export * from "./DashHeader.vue?vue&type=script&lang=js&"
import style0 from "./DashHeader.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DashHeader.vue?vue&type=style&index=1&id=538a1eee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538a1eee",
  null
  
)

export default component.exports